import { createSelector } from 'reselect';
import { loggedInUserUsernameSelector, selectedUserDetailsSelector, selectedUserSelector } from './selectors';

/**
 * Memoized selector that aggregates selected user details, the selected user, and the logged-in user's username.
 *
 * Useful for user edit pages that need to display the user being edited.
 *
 * @function
 * @returns {Object} An object containing:
 *   @property {Object|undefined} selectedUserDetails - Detailed information about the selected user.
 *   @property {Object|undefined} selectedUser - The selected user object.
 *   @property {string|undefined} loggedInUserUsername - The username of the currently logged-in user.
 *
 * @example
 * const { selectedUserDetails, selectedUser, loggedInUserUsername } = useSelector(userEditPageSelector);
 */
export const userEditPageSelector = createSelector(
    [selectedUserDetailsSelector, selectedUserSelector, loggedInUserUsernameSelector],
    (selectedUserDetails, selectedUser, loggedInUserUsername) => ({
        selectedUserDetails,
        selectedUser,
        loggedInUserUsername,
    }),
);
